import { ReduxAction } from '../redux/redux-actions';
import types from './types';

export type ToggleAction = ReduxAction;
export function toggleDrawerAction() {
    return {
        type: types.TOGGLE,
    };
}
